import { serializable, alias, object, list, primitive } from "serializr";
import { IdNameModel } from "./branches.model";

class BranchModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("is_active", primitive()))
  isActive?: number;
}

export class InstituteTutorFiltersModel {

  @serializable(alias("branch_id", primitive()))
  branchId?: number;

  @serializable(alias("name", primitive()))
  name?: string;

  @serializable(alias("institute_id", primitive()))
  instituteId?: number;

  @serializable(alias("current_page", primitive()))
  currentPage?: number;

  @serializable(alias("page_size", primitive()))
  pageSize?: number;

}
export class InstituteTutorSectionsModel extends IdNameModel {

  @serializable(alias("tutor_subjects", list(object(IdNameModel))))
  tutorSubjects?: IdNameModel[];

}
export class InstituteTutorClassRoomSubjectsModel extends IdNameModel {
  @serializable(alias("class_teacher", primitive()))
  classTeacher?: boolean;

  @serializable(alias("tutor_sections", list(object(InstituteTutorSectionsModel))))
  tutorSections?: InstituteTutorSectionsModel[];

}

export class InstituteTutorModel {
  @serializable(alias("id", primitive()))
  id?: number;

  @serializable(alias("id", primitive()))
  key?: number;

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("full_name", primitive()))
  fullName?: string;

  @serializable(alias("qualification", primitive()))
  qualification?: string;

  @serializable(alias("display_picture_url", primitive()))
  displayPictureUrl?: string;

  @serializable(alias("gender", primitive()))
  gender?: string;

  @serializable(alias("is_active", primitive()))
  isActive?: string;

  @serializable(alias("tutor_class_rooms", list(object(InstituteTutorClassRoomSubjectsModel))))
  tutorClassRooms?: InstituteTutorClassRoomSubjectsModel[];

  @serializable(alias("branch", object(BranchModel)))
  branch?: BranchModel;

  @serializable(alias("institutes", object(IdNameModel)))
  institute?: IdNameModel;
}

export class InstituteTutorCreateModel {

  @serializable(alias("email", primitive()))
  email?: string;

  @serializable(alias("phone_number", primitive()))
  phoneNumber?: string;

  @serializable(alias("full_name", primitive()))
  fullName?: string;

  @serializable(alias("password", primitive()))
  password?: string;

  @serializable(alias("is_active", primitive()))
  isActive?: string;

  @serializable(alias("section_subjects", list(primitive())))
  expertise?: number[];

  @serializable(alias("branch_id", primitive()))
  branchId?: number;

  @serializable(alias("branch_class_rooms", primitive()))
  branchClassRoomId?: number;
}
